import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { AlertComponent } from './alert.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MatDialogModule
    ],
    declarations: [AlertComponent],
    exports: [AlertComponent],
})
export class AlertModule {
}
